import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { authStoreStateSelector } from '~/selectors';

export const useLoggedInEmployeeId = (): number => {
  return useSelector((state: StoreState) => {
    return authStoreStateSelector(state).userDetails!.employeeId;
  });
};
